module.exports = __webpack_public_path__ + "img/water2.2d412e48.jpg";